import {
	CircularProgress,
	Stack,
	TextField,
	Typography
} from "@mui/material";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { ColorScheme } from "../../Themes/ColorScheme";
import { ApiContext } from "../ApiContext";
import BigButton from "../Common/BigButton";

export const ForgotPassword = ({ switchComponent, passUserEmail }) => {
	const [userEmail, setUserEmail] = useState("");
	const [resettingPassword, setResettingPassword] = useState(false);

	const { ApiCall } = useContext(ApiContext);
	const { t } = useTranslation();

	const restoreAccount = (e) => {
		setResettingPassword(true);
		e.preventDefault();

		ApiCall("POST", "user/reset_password", {
			email: userEmail
		})
			.then(() => {
				switchComponent("validation");
				passUserEmail(userEmail);
				setResettingPassword(false);
			})
			.catch(() => {
				setUserEmail("");
				setResettingPassword(false);
			});
	};

	const validateEmail = (email) => {
		const re = /\S+@\S+\.\S+/;
		return re.test(email);
	};

	return (
		<form onSubmit={restoreAccount}>
			<Typography align="center" style={{ margin: 30 }} color={ColorScheme.secondary}>
				{t("login.email_recovery_description")}
			</Typography>
			<Stack spacing={3}>
				<Typography sx={{ color: ColorScheme.lightGrey, fontSize: "14px" }}>
					{t("login.email_label")}*
				</Typography>

				<TextField
					placeholder={t("login.insert_email")}
					sx={{
						backgroundColor: ColorScheme.lightGrey,
						borderRadius: "5px"
					}}
					id="username"
					variant="outlined"
					margin="dense"
					fullWidth={true}
					size="small"
					onChange={(e) => setUserEmail(e.target.value)}
				/>

				<Stack
					style={{ justifyContent: "center", alignItems: "center" }}
				>
					{!resettingPassword ? (
						<Stack spacing={3} style={{ width: "100%" }}>
							<BigButton
								text={t("buttons.continue")}
								activity={resettingPassword}
								borderColor={ColorScheme.primary}
								backgroundColor={ColorScheme.buttonPrimary}
								textColor={ColorScheme.textPrimary}
								width="100%"
								action={restoreAccount}
								disabled={!validateEmail(userEmail)}
							/>
							<BigButton
								text={t("buttons.return_to_login")}
								backgroundColor={ColorScheme.transparent}
								textColor={ColorScheme.textPrimary}
								borderColor={ColorScheme.secondary}
								width="100%"
								action={() => switchComponent("login")}
							/>
						</Stack>
					) : (
						<CircularProgress color="info" />
					)}
				</Stack>
			</Stack>
		</form>
	);
};
